import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Upload, UploadFile, notification } from 'antd';
import { RcFile, UploadChangeParam, UploadProps } from 'antd/lib/upload';
import classNames from 'classnames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomUploadProps } from '../../interfaces';
import { UpdateImg, UploadWrapper } from './styles';
import './styles.scss';

const getBase64 = (img: RcFile, callback: (url: string) => void) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result as string));
  reader.readAsDataURL(img);
};

const beforeUpload = (file: RcFile) => {
  const isJpgOrPng =
    file.type === 'image/jpeg' ||
    file.type === 'image/png' ||
    file.type === 'image/jpg';
  if (!isJpgOrPng) {
    notification.error({ message: 'You can only upload JPG/PNG file!' });
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    notification.error({ message: 'Image must smaller than 2MB!' });
  }
  return isJpgOrPng && isLt2M;
};

const CustomImageUpload = (props: CustomUploadProps) => {
  const { value, className, disabled, ...rest } = props;
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState<string>();

  const handleChange: UploadProps['onChange'] = (
    info: UploadChangeParam<UploadFile>,
  ) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      setImageUrl('');
    }
    if (info.file.status !== 'uploading') {
      getBase64(info.file.originFileObj as RcFile, url => {
        setImageUrl(url);
        setLoading(false);
      });
    }
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>{t('Upload')}</div>
    </div>
  );

  return (
    <UploadWrapper
      className={classNames(className, { 'hide-border': disabled })}
    >
      <Upload
        {...rest}
        disabled={disabled}
        showUploadList={false}
        listType="picture-card"
        accept=".jpg,.png,.jpeg"
        className="avatar-uploader"
        beforeUpload={beforeUpload}
        customRequest={props.customRequest}
        onChange={info => {
          console.info(info);
          handleChange(info);
          props.onChange?.(info?.file?.response?.url);
        }}
      >
        {imageUrl || value ? (
          <UpdateImg
            src={imageUrl || value}
            alt="avatar"
            style={{ width: '100%' }}
          />
        ) : (
          uploadButton
        )}
      </Upload>
    </UploadWrapper>
  );
};

export default CustomImageUpload;
